import React from "react";

export default function Step3() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 border border-icon/50 w-8 h-8 rounded-full flex justify-center items-center text-lg font-semibold text-icon">
          3
        </div>
        <h1 className="">
          Aqui, clique em <b>CONTINUAR NA WEB</b>.
        </h1>
      </div>
      <div className="mt-2.5 ml-[42px]">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/steady-gainz.firebasestorage.app/o/OpenAccount%2FIMG_3606.jpg?alt=media&token=803dcff0-0a16-4f2f-a7fc-eaeb218f859c"
          className="w-72"
          alt=""
        />
      </div>
    </div>
  );
}
